<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-row class="align-items-center">
        <b-col lg="12">
          <div class="blockquote">
            <h4>Order Info</h4>
          </div>
        </b-col>
      </b-row>
      <b-container>
        <b-row cols="3">
          <b-col>
            <label class="col-form-label">Order Name:</label>
            <span class="p-3">{{ form.batchName }}</span>
          </b-col>

          <b-col>
            <label class="col-form-label">Order No.:</label>
            <span class="p-3">{{ form.number }}</span>
          </b-col>
          <b-col>
            <label class="col-form-label">Status:</label>
            <span class="p-3">{{ form.statusName }}</span>
          </b-col>
          <b-col>
            <label class="col-form-label">Total Boxes:</label>
            <span class="p-3">{{ form.totalBoxes }}</span>
          </b-col>
          <b-col>
            <label class="col-form-label">Number of boxes per box:</label>
            <span class="p-3">{{ form.quantityPackingBox }}</span>
          </b-col>
          <b-col>
            <label class="col-form-label">Number of boxes produced:</label>
            <span class="p-3">{{ form.productionCount }}</span>
          </b-col>
          <b-col>
            <label class="col-form-label">Number of devices:</label>
            <span class="p-3">{{ form.quantityPackingBox }}</span>
          </b-col>
          <b-col>
            <label class="col-form-label">Remarks:</label>
            <span class="p-3">{{ form.remarks }}</span>
          </b-col>
          <b-col>
            <label class="col-form-label">Create Time:</label>
            <span class="p-3">{{
              form.createTime ? getLocalTimes(form.createTime) : ""
            }}</span>
          </b-col>
        </b-row>
      </b-container>
      <br />
      <br />
      <b-row
        class="align-items-center"
        v-if="form.status == 5 || form.status == 14 || form.status == 24"
      >
        <b-col lg="12">
          <div class="blockquote">
            <h4>Production Result</h4>
          </div>
        </b-col>
      </b-row>
      <b-container
        v-if="form.status == 5 || form.status == 14 || form.status == 24"
      >
        <b-row cols="3">
          <b-col>
            <label class="col-form-label">Actual Quantity:</label>
            <span class="p-3">{{ form.normalQuantity }}</span>
          </b-col>

          <b-col>
            <label class="col-form-label">Abnormal Quantity:</label>
            <span class="p-3">{{ form.abnormalQuantity }}</span>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
    <b-button variant="outline-secondary" @click="returnPage">Go Back</b-button>
  </Layout>
</template>
<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import timeZoneConversion from "@/components/widgets/timeZoneConversion";

export default {
  components: {
    Layout,
    PageHeader,
    timeZoneConversion,
  },
  data() {
    return {
      title: "Packing Box Orders Details",
      items: [
        {
          text: "UNI-CORE",
          // href: "/"
        },
        {
          text: "Production Mgmt",
          // href: "/"
        },
        {
          text: "Packing Box Orders Details",
          active: true,
        },
      ],
      form: {},
      types: {
        statuss: [
          {
            text: "Production information to be confirmed",
            value: 0,
            disabled: false,
          },
          {
            text: "Production information has been confirmed",
            value: 1,
            disabled: false,
          },
          { text: "To be production", value: 1, disabled: false },
          { text: "In Production", value: 2, disabled: false },
          { text: "Completed", value: 3, disabled: false },
        ],
      },
    };
  },
  computed: {},

  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.query.id) {
        this.$api.packingBoxOrder
          .selectByPackingBoxOrderId(this.$route.query)
          .then((res) => {
            if (res.success && res.data) {
              this.form = res.data;
            } else {
              if (res.message) {
                this.$bvToast.toast(res.message);
              }
            }
          });
      } else {
        this.$bvToast.toast("id?");
      }
    },
    formatterStatus(value) {
      let a = "";
      this.types.statuss.filter((item) => {
        if (value === item.value) {
          a = item.text;
        }
      });
      return a;
    },
    returnPage() {
      this.$router.go(-1);
    },
    getLocalTimes(value) {
      return timeZoneConversion.getLocalTimes(value);
    },
  },
};
</script>
<style>
.blockquote {
  padding: 10px 10px;
  border-left: 5px solid #aaaaff;
}
</style>
